import script from "./deboneControls.vue?vue&type=script&setup=true&lang=js"
export * from "./deboneControls.vue?vue&type=script&setup=true&lang=js"

import "./deboneControls.vue?vue&type=style&index=0&id=ae888b78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae888b78"]])

export default __exports__